import { ExternalSystem } from '@monetize/types/app';
import {
  AccountingIcon,
  AttioIcon,
  HubSpotIcon,
  NetsuiteIcon,
  QuickbooksIcon,
  SalesforceIcon,
  XeroIcon,
} from '@monetize/ui/icons';
import { ComponentType } from 'react';

export const EXTERNAL_SYSTEM_ICONS: Record<ExternalSystem, ComponentType> = {
  [ExternalSystem.SALESFORCE]: SalesforceIcon,
  [ExternalSystem.HUBSPOT]: HubSpotIcon,
  [ExternalSystem.ATTIO]: AttioIcon,
  [ExternalSystem.QUICKBOOKS]: QuickbooksIcon,
  [ExternalSystem.NETSUITE]: NetsuiteIcon,
  [ExternalSystem.XERO]: XeroIcon,
  // `RilletIcon` is a wordmark (106x23), which renders as an illegible smudge
  // in an 18px square slot. Swap it in once there is a square Rillet mark.
  [ExternalSystem.RILLET]: AccountingIcon,
};
